// BSD 自制日历（2026-10-23）：负责人在 iPhone 上反复反映日期框「日期点的都没有反应」「这个日期行 有些位置点击了没反应」「点了还是没反应」「还是不行」。
// iPhone 原生日期框的点击区域和弹出行为不可控，所以不再用原生日期选择器：
// 外框是一个按钮（data-bsd-dp-trigger），里面放一个隐藏输入框存值（YYYY-MM-DD）。点外框任何位置都打开这个日历；
// 选好后写回隐藏输入框，派发 input 和 change，首页计划卡（bsd-home.js）和客服页（bsd-care.js）原来的计算照常工作。
// 早于输入框 min 的日期不能选（计划卡最早明天）；点日历外面、按 Esc 关闭；同一个弹层给页面上所有日期框共用。
(function () {
  if (window.BsdDatepicker) return;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  var CHEV_L = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var pop = null;
  var titleEl = null;
  var gridEl = null;
  var prevBtn = null;
  var nextBtn = null;
  var current = null; // { trigger, input }
  var view = null; // 正在看的月份（当月 1 号）

  function today() {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }
  function iso(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function parse(v) {
    var p = (v || '').split('-');
    var y = Number(p[0]);
    if (p.length !== 3 || y < 1900) return null;
    var d = new Date(y, Number(p[1]) - 1, Number(p[2]));
    return isNaN(d.getTime()) ? null : d;
  }
  function inputOf(trigger) {
    var id = trigger.getAttribute('data-bsd-dp-for');
    return (id && document.getElementById(id)) || trigger.querySelector('input');
  }
  function minOf(input) {
    return parse(input.getAttribute('min'));
  }
  function sameDay(a, b) {
    return a && b && a.getTime() === b.getTime();
  }

  function build() {
    if (pop) return;
    pop = document.createElement('div');
    pop.className = 'bsd-dp';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Choose a date');
    pop.hidden = true;
    var dow = DOW.map(function (d) { return '<span aria-hidden="true">' + d + '</span>'; }).join('');
    pop.innerHTML =
      '<div class="bsd-dp__head">' +
      '<button type="button" class="bsd-dp__nav" data-bsd-dp-nav="-1" aria-label="Previous month">' + CHEV_L + '</button>' +
      '<p class="bsd-dp__title" aria-live="polite"></p>' +
      '<button type="button" class="bsd-dp__nav" data-bsd-dp-nav="1" aria-label="Next month">' + CHEV_R + '</button>' +
      '</div>' +
      '<div class="bsd-dp__dow">' + dow + '</div>' +
      '<div class="bsd-dp__grid"></div>';
    titleEl = pop.querySelector('.bsd-dp__title');
    gridEl = pop.querySelector('.bsd-dp__grid');
    prevBtn = pop.querySelector('[data-bsd-dp-nav="-1"]');
    nextBtn = pop.querySelector('[data-bsd-dp-nav="1"]');
    pop.addEventListener('click', onPopClick);
    pop.addEventListener('keydown', onPopKey);
    document.body.appendChild(pop);
  }

  function render() {
    var input = current.input;
    var min = minOf(input);
    var sel = parse(input.value);
    var now = today();
    var y = view.getFullYear();
    var m = view.getMonth();
    titleEl.textContent = MONTHS[m] + ' ' + y;
    // 有 min 时不能翻到 min 所在月份之前
    prevBtn.disabled = !!(min && (y < min.getFullYear() || (y === min.getFullYear() && m <= min.getMonth())));
    var first = new Date(y, m, 1).getDay();
    var days = new Date(y, m + 1, 0).getDate();
    var html = '';
    for (var i = 0; i < first; i++) html += '<span class="bsd-dp__pad" aria-hidden="true"></span>';
    for (var d = 1; d <= days; d++) {
      var day = new Date(y, m, d);
      var off = !!(min && day < min);
      var cls = 'bsd-dp__day';
      if (sameDay(day, now)) cls += ' is-today';
      if (sameDay(day, sel)) cls += ' is-selected';
      var label = day.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
      html += '<button type="button" class="' + cls + '" data-bsd-dp-day="' + iso(day) + '" aria-label="' + label + '"' +
        (sameDay(day, sel) ? ' aria-pressed="true"' : '') + (off ? ' disabled' : '') + '>' + d + '</button>';
    }
    gridEl.innerHTML = html;
  }

  function place() {
    if (!current) return;
    var r = current.trigger.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var edge = 12;
    // 手机和外框一样宽，电脑约 320px；左边和外框对齐，不超出屏幕
    var w = vw < 750 ? Math.min(Math.max(r.width, 288), vw - edge * 2) : 320;
    var left = Math.min(Math.max(r.left, edge), vw - w - edge);
    pop.style.width = Math.round(w) + 'px';
    pop.style.left = Math.round(left + window.scrollX) + 'px';
    pop.style.top = Math.round(r.bottom + window.scrollY + 8) + 'px';
  }

  function reveal() {
    var pr = pop.getBoundingClientRect();
    var vh = window.innerHeight;
    if (pr.bottom > vh - 12) window.scrollBy({ top: pr.bottom - vh + 24, behavior: 'smooth' });
  }

  function open(trigger) {
    var input = inputOf(trigger);
    if (!input) return;
    build();
    current = { trigger: trigger, input: input };
    var sel = parse(input.value);
    var min = minOf(input);
    var base = sel || (min && min > today() ? min : today());
    view = new Date(base.getFullYear(), base.getMonth(), 1);
    render();
    pop.hidden = false;
    place();
    trigger.setAttribute('aria-expanded', 'true');
    reveal();
    // 键盘打开时把焦点放进日历；触屏不挪焦点，免得页面跳动
    if (!window.matchMedia('(hover: none)').matches) {
      var f = gridEl.querySelector('.is-selected:not([disabled])') || gridEl.querySelector('.bsd-dp__day:not([disabled])');
      if (f) f.focus({ preventScroll: true });
    }
  }

  function close(restore) {
    if (!current) return;
    pop.hidden = true;
    current.trigger.setAttribute('aria-expanded', 'false');
    if (restore) current.trigger.focus({ preventScroll: true });
    current = null;
  }

  function pick(value) {
    var input = current.input;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    // 电脑上焦点回到外框（键盘可以接着用）；触屏不挪焦点，免得外框一直亮着焦点框
    close(!window.matchMedia('(hover: none)').matches);
  }

  function onPopClick(e) {
    var nav = e.target.closest('[data-bsd-dp-nav]');
    if (nav) {
      if (nav.disabled) return;
      view = new Date(view.getFullYear(), view.getMonth() + Number(nav.getAttribute('data-bsd-dp-nav')), 1);
      render();
      return;
    }
    var day = e.target.closest('[data-bsd-dp-day]');
    if (day && !day.disabled) pick(day.getAttribute('data-bsd-dp-day'));
  }

  function onPopKey(e) {
    var btn = e.target.closest && e.target.closest('[data-bsd-dp-day]');
    var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
    if (!btn || !step) return;
    e.preventDefault();
    var d = parse(btn.getAttribute('data-bsd-dp-day'));
    d.setDate(d.getDate() + step);
    if (d.getMonth() !== view.getMonth() || d.getFullYear() !== view.getFullYear()) {
      var min = minOf(current.input);
      if (min && d < min) return;
      view = new Date(d.getFullYear(), d.getMonth(), 1);
      render();
    }
    var next = gridEl.querySelector('[data-bsd-dp-day="' + iso(d) + '"]');
    if (next && !next.disabled) next.focus();
  }

  // 外框是 button，iPhone 上点按一定会触发 click；点同一个外框再点一次是收起
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-bsd-dp-trigger]');
    if (!trigger) return;
    e.preventDefault();
    if (current && current.trigger === trigger) {
      close(false);
      return;
    }
    close(false);
    open(trigger);
  });
  // 点日历和外框以外的地方收起。用 pointerdown：iPhone 上点普通区域不一定触发 click
  document.addEventListener('pointerdown', function (e) {
    if (!current) return;
    if (pop.contains(e.target)) return;
    var trigger = e.target.closest && e.target.closest('[data-bsd-dp-trigger]');
    if (trigger === current.trigger) return;
    close(false);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) close(true);
  });
  window.addEventListener('resize', place);

  window.BsdDatepicker = { open: open, close: close };
})();
